<template>
  <ul class="checkbox-list flex-wrap">
    <li
      class="checkbox-item"
      :class="{ active: selectList.length == list.length }"
      @click="selectAll"
    >
      全部
    </li>
    <li
      v-for="item in list"
      :key="item.value"
      class="checkbox-item"
      :class="{ active: selectList.includes(item.value) }"
      @click="updateCheck(item.value)"
    >
      {{ item.text }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    list: Array,
    selectList: Array,
    already: Boolean
  },
  watch: {
    already(val) {
      if (val) {
        this.$emit(
          'updateCheck',
          this.list.map(e => {
            return e.value
          })
        )
      }
    }
  },
  methods: {
    updateCheck(value) {
      const index = this.selectList.indexOf(value)
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(value)
      }
      this.$emit('updateCheck', this.selectList)
    },
    selectAll() {
      if (this.selectList.length == this.list.length) {
        this.$emit('updateCheck', [])
      } else {
        this.$emit(
          'updateCheck',
          this.list.map(e => {
            return e.value
          })
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-list {
  flex-wrap: wrap;
  .checkbox-item {
    width: 80px;
    height: 40px;
    border-radius: 6px;
    border: solid 1px #ebebeb;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    color: $color_normal;
    font-size: 14px;
    cursor: pointer;
    &.active {
      border-color: $color_blue;
      color: $color_blue;
    }
  }
}
</style>
